/**
 * Get next slide index depending on current slide index
 */
export const getIsNextSlide = ({ i, currentRealIndex, items, offset = 1 }) => {
	if (currentRealIndex + offset >= items.length) {
		return currentRealIndex + offset - items.length === i % items.length;
	} else {
		return currentRealIndex + offset === i % items.length;
	}
};
